module.exports = __webpack_public_path__ + "img/app.42052924.jpg";